import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { compact } from 'lodash';

import SeverityLabel from 'components/SeverityLabel';

import Link from 'elements/Link';
import { ListTable } from 'base-components';
import StatusSpan from 'elements/StatusSpan';
import TextDiv from 'elements/TextDiv';

import {
  getAssetStatusText,
  getOdometerText,
  getSerialNumber,
} from 'utils/asset';
import { getOutputText } from 'utils/widget';

import messages from './messages';

function AssetListRow({ assetInfo }) {
  // asset ids
  const assetId = assetInfo.get('id');
  const unitNumber = getOutputText(assetInfo.get('unitNumber'));
  const rawVin = assetInfo.get('vinNumber');
  const vinNumber = getOutputText(rawVin);
  const serialNumber = getSerialNumber(rawVin);
  // asset details
  const make = getOutputText(assetInfo.get('make'));
  const model = getOutputText(assetInfo.get('model'));
  const year = getOutputText(assetInfo.get('year'));
  const engine = getOutputText(assetInfo.get('engine'));
  const odometerReading = assetInfo.getIn(['odometer', 'reading']);
  const odometerUnit = assetInfo.getIn(['odometer', 'unit']);
  const odometerText = getOdometerText(odometerReading, odometerUnit);
  const odometer = getOutputText(odometerText);
  // asset status
  const pmStatus = assetInfo.get('pmStatus');
  // asset severity info
  const severityColor = assetInfo.get('severityColor');
  const severityCount = Number(assetInfo.get('severityCount'));

  return (
    <ListTable.Row modifiers={['lined']}>
      <ListTable.Data>
        <Link to={`/assets/${assetId}`} modifiers={['heavy', 'uppercase']}>
          {unitNumber}
        </Link>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv modifiers={['bright']}>{serialNumber}</TextDiv>
      </ListTable.Data>
      <ListTable.Data flex={1.5} minWidth={150}>
        <TextDiv modifiers={['bright']}>{vinNumber}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>{make}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>{model}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>{year}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>{engine}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>{odometer}</TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <TextDiv>
          <StatusSpan modifiers={compact(['bold', pmStatus, 'capitalize'])}>
            {getAssetStatusText('pmStatus', pmStatus, messages.pmStatus)}
          </StatusSpan>
        </TextDiv>
      </ListTable.Data>
      <ListTable.Data>
        <SeverityLabel color={severityColor} value={severityCount} small />
      </ListTable.Data>
    </ListTable.Row>
  );
}

AssetListRow.propTypes = {
  assetInfo: ImmutablePropTypes.contains({
    id: PropTypes.string,
    unitNumber: PropTypes.string,
    vinNumber: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    engine: PropTypes.string,
    pmStatus: PropTypes.string,
    odometer: PropTypes.shape({
      reading: PropTypes.string,
      unit: PropTypes.string,
    }),
  }).isRequired,
};

export default AssetListRow;



// WEBPACK FOOTER //
// ./components/AssetDisplayElement/AssetListRow.js